<script>
import formInput from "@wielink-application/shared/js/mixins/formInput";

export default {
	mixins: [formInput],
	computed : {
		previewUrl () {
			if (this.asset_id) {
				return route('api.v1.assets.preview', {asset: this.asset_id});
			}
			return 'about:blank';
		}
	},
	data() {
		return {
			showImage: false,
			showFile: false
		}
	},
	watch : {
		modelValue : function(newValue, oldValue) {
			if (newValue && Object.keys(newValue).length == 0) {
				this.showImage = false;
				this.showFile = false;
				document.getElementById(this.renderedId).value = '';
			}
		},
		asset_id : async function(newValue, oldValue){
			if (newValue > 0) {
				let asset = await Helpers.Ajax.get(route('api.v1.assets.show', {asset: newValue}), {},{success : () => {}});
				if (asset.mimetype.match('image')) {
					this.showImage = true;
					this.showFile = false;
				} else {
					this.showImage = false;
					this.showFile = true;
				}
			} else {
				this.showImage = false;
				this.showFile = false;
			}
		}
	},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'type': {
			type: String,
			default: 'text'
		},
		'label': {
			type: String,
			required: false
		},
		'asset_id': {
			type: Number,
			required: false
		}
	},
	methods: {
		async convertToBase64(file) {
			return new Promise((resolve) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					resolve(reader.result);
				};
				reader.readAsDataURL(file);
			});
		},
		async changeFile(e) {
			let file = e.target.files[0];
			let base64 = await this.convertToBase64(file)
			this.$refs.preview.setAttribute('src', base64);
			if (file.type.match('image')) {
				this.showImage = true;
				this.showFile = false;
			} else {
				this.showImage = false;
				this.showFile = true;
			}
			this.changeModelValueTo({
				name : file.name,
				type : file.type,
				size : file.size,
				lastModified : file.lastModified,
				base64 : base64,
			})
		}
	}
}
</script>

<template>
	<div v-show="showFile" ref="preview" class="w-100">
		Bestand: <i class="bi-filetype-raw " style="color: #3f5d81"></i> <span v-if="form.base64" v-html="form.orig_name ?? form.base64.name"></span>
	</div>
	<img v-show="showImage" ref="preview" :src="previewUrl" class="w-100" style="max-width: 200px; max-height: 200px;" />
	<input
		:name="name"
		v-bind="$attrs"
		@input="changeFile"
		type="file"
		:id="renderedId"
		:class="{'form-control': true, 'border-danger': hasError}"
	>
	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>
